import React, { useState, useMemo, useEffect } from 'react';
import {
  Button,
  Typography,
  TextField,
  Menu,
  MenuItem,
} from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import { Formik } from 'formik';
import { useRootStore } from '../../../../stores/BridgeProvider';
import {
  StyledForm,
  WideBox,
  FlexDiv,
  ButtonFlex,
  FormRow,
} from '../../../styles/styles';
import Spinner from '../../../util/Spinner';
import SimpleSelect from '../../../util/SimpleSelect';
import {
  formFieldGenerator,
  initialValueGenerator,
} from '../../../util/TemplateUtils';
import { DealTemplateSchema } from '../../../../validation';
import FieldModal from './FieldModal';
import RenderPropModal from '../../../dealMapper/common/RenderPropModal';
import DTFormPreview from './DTFormPreview';
import DealFormPreview from './DealFormPreview';

const DealPreview = ({ json, updateTemplateJSON }) => {
  const { template, items } = json;
  const { Deals, DealTransactions } = template;

  const addNewDT = () => {
    const newDT = {
      Price: null,
      Quantity: null,
      TranType: null,
      DealTitle: Deals[0].Title,
      ContactName: null,
      Description: '',
      TranCategoryName: '',
    };
    const newDTs = [...DealTransactions, newDT];

    updateTemplateJSON({
      template: {
        Deals,
        DealTransactions: newDTs,
      },
      items,
    });
  };

  const genDeal = Deals[0];
  // console.log(genDeal);

  //   AgentContactName: '$AgentContactName';
  //   BillableDate: '$TransactionDate';
  //   ContractDate: '%CurrentDate';
  //   DealNumber: 'AUTO-GENERATE';
  //   Description: '$Description';
  //   PayableDate: '$TransactionDate';
  //   StatusName: '$StatusName';
  //   Title: '$Title';
  //   TransactionDate: '$TransactionDate';

  const deleteDT = index => {
    const newDTs = json.template.DealTransactions.slice();
    newDTs.splice(index, 1);

    updateTemplateJSON({
      template: {
        Deals,
        DealTransactions: newDTs,
      },
      items,
    });
  };

  return (
    <FlexDiv>
      <WideBox style={{ minWidth: '700px' }}>
        <Typography variant="h4" gutterBottom>
          Deal Preview
        </Typography>
        <Typography
          variant="p"
          style={{ paddingTop: '10px', display: 'block' }}
        >
          A deal created from this template will appear like this:
        </Typography>
        <div style={{ textAlign: 'left' }}>
          <Typography variant="h4">Deal:</Typography>
          <DealFormPreview
            deal={genDeal}
            json={json}
            updateTemplateJSON={updateTemplateJSON}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '2rem',
            }}
          >
            <Typography variant="h4">
              Transactions ({DealTransactions.length}):
            </Typography>

            <Button size="small" disableRipple onClick={() => addNewDT()}>
              <CirclePlusIcon
                style={{ marginRight: '4px', marginLeft: '-3px' }}
              />{' '}
              Add Transaction
            </Button>
          </div>
          <Typography
            variant="p"
            style={{ paddingTop: '10px', display: 'block' }}
          >
            Transactions added here will be the default transactions for any
            deal created from this template.
          </Typography>

          {DealTransactions.map((dt, i) => {
            return (
              <DTFormPreview
                i={i}
                dt={dt}
                deleteDT={deleteDT}
                updateTemplateJSON={updateTemplateJSON}
                json={json}
              />
            );
          })}
        </div>
      </WideBox>
    </FlexDiv>
  );
};

export default DealPreview;
